import React from 'react';
import { Icon } from '@iconify/react';

export interface ErrorDisplayProps {
    errorData: {
        error?: string;
        body?: string | object;
        parsedBody?: {
            status_code?: number | string;
            message?: string;
            [key: string]: any;
        };
    };
    className?: string;
}

export const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ errorData, className = '' }) => {
    if (!errorData) return null;

    return (
        <div className={`bg-red-50 dark:bg-red-500/10 border border-red-200 rounded-lg p-6 ${className}`} role="alert" aria-live="polite">
            <div className="flex items-start gap-3">
                <Icon icon="mdi:alert-circle" className="w-6 h-6 text-red-600 flex-shrink-0 mt-1" aria-hidden="true" />
                <div className="flex-1">
                    <h3 className="text-lg font-semibold text-red-700 dark:text-red-400 mb-3">Error</h3>

                    {errorData.error && (
                        <div className="mb-3">
                            <p className="text-sm font-medium text-red-600 dark:text-red-400 mb-1">Error Message:</p>
                            <p className="text-sm text-red-700 dark:text-red-400 bg-content1 rounded px-3 py-2 border border-red-200">
                                {errorData.error}
                            </p>
                        </div>
                    )}

                    {errorData.parsedBody && (
                        <div className="space-y-2">
                            {errorData.parsedBody.status_code && (
                                <div>
                                    <p className="text-sm font-medium text-red-600 dark:text-red-400">Status Code:</p>
                                    <p className="text-sm text-red-700 dark:text-red-400">{errorData.parsedBody.status_code}</p>
                                </div>
                            )}
                            {errorData.parsedBody.message && (
                                <div>
                                    <p className="text-sm font-medium text-red-600 dark:text-red-400">Message:</p>
                                    <p className="text-sm text-red-700 dark:text-red-400 bg-content1 rounded px-3 py-2 border border-red-200">
                                        {errorData.parsedBody.message}
                                    </p>
                                </div>
                            )}
                        </div>
                    )}

                    {errorData.body && !errorData.parsedBody && (
                        <div>
                            <p className="text-sm font-medium text-red-600 dark:text-red-400 mb-1">Response Body:</p>
                            <p className="text-sm text-red-700 dark:text-red-400 bg-content1 rounded px-3 py-2 border border-red-200 font-mono">
                                {typeof errorData.body === 'string' ? errorData.body : JSON.stringify(errorData.body)}
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ErrorDisplay;

